export default {

  navAreaList (state) {
    const lis = state.NavAreaCategorys
    const Arrs = []
    Array.prototype.slice.call(lis).forEach((item, index) => {
      const Arr = Math.floor(index / 11)
      if (!Arrs[Arr]) {
        Arrs[Arr] = []
      }
      Arrs[Arr].push(item)
    })
    return Arrs
  },
  navTopicList (state) {
    let nav = {}
    const lis = state.indexNavList
    lis.forEach((item) => {
      nav[item.value] = item.subdata 
    })
    return nav
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js